export type CallDirection = 'INBOUND' | 'OUTBOUND' | 'INTERNAL';

export const CallDirection = {
  INBOUND: 'INBOUND' as CallDirection,
  OUTBOUND: 'OUTBOUND' as CallDirection,
  INTERNAL: 'INTERNAL' as CallDirection,
};
